import React, { Component } from "react";
import { message, Row, Col, Switch, Divider, Input, Popconfirm } from "antd";
import { DisconnectOutlined, MobileOutlined } from "@ant-design/icons";
import moment from "moment";
import { connect } from "react-redux";
import axios from "axios";
import {
  ModalItem,
  Form,
  FormItem,
  InputItem,
  ButtonItem,
  ErrorItem,
} from "./Items";

class ModalUsuarioMovil extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    modoEdicion: false,
    usuarioMovilId: null,
    dispositivoChecada: null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.cargarDatos();
    }
  }

  async cargarDatos() {
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "usuariosMovil/consultarUsuarioMovil",
        {
          referenciaId: this.props.referenciaId,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      );

      if (res.data && res.data._id) {
        // Modo edición — pre-llenar con datos actuales
        this.setState({
          modoEdicion: true,
          usuarioMovilId: res.data._id,
          dispositivoChecada: res.data.dispositivoChecada?.deviceId ? res.data.dispositivoChecada : null,
        });
        this.formRef.current?.setFieldsValue({
          nombreUsuario: res.data.nombreUsuario,
          correo: res.data.correo || "",
          estado: res.data.estado === 1,
          nuevaPassword: "",
        });
      } else {
        // Modo creación — sugerir nombre de usuario a partir del nombre
        this.setState({ modoEdicion: false, usuarioMovilId: null, dispositivoChecada: null });
        const sugerido = this.generarUsernameSugerido(this.props.nombreSugerido);
        this.formRef.current?.setFieldsValue({
          nombreUsuario: sugerido,
          correo: this.props.correoSugerido || "",
          passwordTemporal: "",
        });
      }
    } catch {
      message.error("Error al consultar usuario móvil");
    }
    this.setState({ loading: false });
  }

  generarUsernameSugerido(nombre) {
    if (!nombre) return "";
    return nombre
      .toLowerCase()
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "") // quita acentos
      .replace(/[^a-z0-9]/g, ".")      // reemplaza espacios/símbolos con punto
      .replace(/\.+/g, ".")            
      .replace(/^\.|\.$/, "");         
  }

  cerrarModal(exitoso = false) {
    this.formRef.current?.resetFields();
    this.setState({ modoEdicion: false, usuarioMovilId: null, dispositivoChecada: null });
    if (exitoso) {
      this.props.onSuccess?.();
    } else {
      this.props.onCancel?.();
    }
  }

  onFinish(values) {
    this.setState({ loading: true });

    const { modoEdicion, usuarioMovilId } = this.state;
    const endpoint = modoEdicion
      ? "usuariosMovil/editarUsuarioMovil"
      : "usuariosMovil/crearUsuarioMovil";

    const payload = modoEdicion
      ? {
          usuarioMovilId,
          nombreUsuario: values.nombreUsuario,
          correo: values.correo || null,
          nuevaPassword: values.nuevaPassword || null,
          estado: values.estado ? 1 : 0,
          empresaId: this.props.empresaId,
        }
      : {
          nombreUsuario: values.nombreUsuario,
          correo: values.correo || null,
          passwordTemporal: values.passwordTemporal,
          tipo: this.props.tipo,
          referenciaId: this.props.referenciaId,
          empresaId: this.props.empresaId,
        };

    axios
      .post(endpoint, payload, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(
            modoEdicion
              ? "Usuario móvil actualizado correctamente"
              : "Usuario móvil creado correctamente"
          );
          this.cerrarModal(true);
        } else if (res.data.success === 1) {
          message.error(res.data.message || "No se pudo guardar el usuario móvil");
        } else {
          message.error("Ocurrió un error, inténtalo de nuevo");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error de conexión");
      });
  }

  desvincularDispositivoChecada() {
    this.setState({ loading: true });
    axios
      .post(
        "usuariosMovil/desvincularDispositivoChecada",
        { usuarioMovilId: this.state.usuarioMovilId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Celular desvinculado");
          this.setState({ dispositivoChecada: null });
        } else if (res.data.success === 1) {
          message.error(res.data.message || "No se pudo desvincular el celular");
        } else {
          message.error("Ocurrió un error, inténtalo de nuevo");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error de conexión");
      });
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    const { visible } = this.props;
    const { modoEdicion, loading, dispositivoChecada } = this.state;

    return (
      <ModalItem
        title={
          <span>
            <MobileOutlined style={{ marginRight: 8 }} />
            {modoEdicion ? "Editar Usuario Móvil" : "Crear Usuario Móvil"}
          </span>
        }
        visible={visible}
        spinning={loading}
        onCancel={() => this.cerrarModal()}
        width={480}
        paddingTop
      >
        <Form
          ref={this.formRef}
          name="formUsuarioMovil"
          layout="vertical"
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
          bottom={
            <Row justify="end" gutter={8}>
              <Col>
                <ButtonItem rojo onClick={() => this.cerrarModal()}>
                  Cancelar
                </ButtonItem>
              </Col>
              <Col>
                <ButtonItem type="primary" htmlType="submit">
                  {modoEdicion ? "Guardar Cambios" : "Crear Usuario"}
                </ButtonItem>
              </Col>
            </Row>
          }
        >
          <FormItem
            label="Nombre de Usuario"
            name="nombreUsuario"
            required
            max={80}
            min={3}
            margin
          >
            <InputItem placeholder="Ej: juan.perez" />
          </FormItem>

          <FormItem
            label="Correo (opcional)"
            name="correo"
            email
            max={200}
            margin
          >
            <InputItem placeholder="correo@ejemplo.com" />
          </FormItem>

          {!modoEdicion && (
            <>
              <Divider style={{ margin: "12px 0" }} />
              <FormItem
                label="Contraseña Temporal"
                name="passwordTemporal"
                required
                min={8}
                max={100}
                margin
              >
                <Input.Password placeholder="Mínimo 8 caracteres" style={{ borderBottom: "1px solid #DADADA", borderRadius: 0 }} />
              </FormItem>
            </>
          )}

          {modoEdicion && (
            <>
              <Divider style={{ margin: "12px 0" }} />
              <FormItem
                label="Nueva Contraseña (dejar vacío para no cambiar)"
                name="nuevaPassword"
                min={8}
                max={100}
                margin
              >
                <Input.Password placeholder="Mínimo 8 caracteres" style={{ borderBottom: "1px solid #DADADA", borderRadius: 0 }} />
              </FormItem>

              <FormItem
                label="Estado"
                name="estado"
                valuePropName="checked"
                margin
              >
                <Switch
                  checkedChildren="Activo"
                  unCheckedChildren="Inactivo"
                />
              </FormItem>

              {dispositivoChecada && (
                <div style={{
                  display: "flex", alignItems: "center", gap: 8,
                  border: "1px solid #e8e8e8", borderRadius: 6, padding: "8px 12px", marginTop: 8,
                  fontSize: 13, color: "#555",
                }}>
                  <MobileOutlined style={{ fontSize: 18, color: "#00BFD6" }} />
                  <span style={{ flex: 1 }}>
                    Celular vinculado para checar: <b>{dispositivoChecada.modelo || "Sin modelo"}</b>
                    {dispositivoChecada.plataforma ? ` (${dispositivoChecada.plataforma})` : ""}
                    {dispositivoChecada.vinculadoAt ? ` desde ${moment(dispositivoChecada.vinculadoAt).format("DD/MM/YYYY HH:mm")}` : ""}
                  </span>
                  {this.props.esMaster && (
                    <Popconfirm
                      title="¿Desvincular este celular? El empleado podrá checar desde el siguiente celular que use."
                      onConfirm={() => this.desvincularDispositivoChecada()}
                      okText="Sí"
                      cancelText="No"
                    >
                      <ButtonItem size="small" rojo icon={<DisconnectOutlined />}>
                        Desvincular
                      </ButtonItem>
                    </Popconfirm>
                  )}
                </div>
              )}
            </>
          )}
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  // Solo el administrador master puede desvincular el celular de checada
  esMaster: state.user.tipo === 0,
});

export default connect(mapStateToProps)(ModalUsuarioMovil);
